/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import * as React from "react";
import { FormControl, InputLabel, MenuItem, Select, SelectProps } from "@mui/material";

type OSDropDownProps<TOptions> = SelectProps & {
  options: TOptions;
  defaultValue?: string;
  getOptionLabel?: (chosenValue: keyof TOptions) => string;
  onChangeCallBack?: (chosenValue: keyof TOptions) => void;
  isDisabled?: (chosenValue: keyof TOptions) => boolean;
};

export const OSDropDown = <TOptions,>(props: OSDropDownProps<TOptions>) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props?.onChangeCallBack?.(event.target.value as keyof TOptions);
  };

  return (
    <FormControl fullWidth={props.fullWidth}>
      <InputLabel id={props?.labelId}>{props?.label}</InputLabel>
      <Select
        {...props}
        labelId={props?.labelId}
        id={props?.id}
        value={props?.value}
        onChange={handleChange}
        autoWidth={props?.autoWidth}
        label={props?.label}
        variant={props?.variant}
      >
        {Object.keys(props?.options).map((k) => (
          <MenuItem key={k} value={k} disabled={props?.isDisabled?.(k as keyof TOptions) ?? false}>
            {props?.getOptionLabel?.(k as keyof TOptions) ?? props?.options[k]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
